<mat-accordion>
  <mat-expansion-panel *ngFor="let customer of relatedCustomers; let k = index">

    <mat-expansion-panel-header>
      <mat-panel-title>
        {{customer.name}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <table class="mat-table data-table">
      <tr>
        <th>Kundenummer</th>
        <td>{{customer.external_id}}</td>
      </tr>
      <tr>

      </tr>
    </table>
    <button mat-raised-button (click)="editCustomer(customer.id)">Zugänge bearbeiten <mat-icon>edit</mat-icon></button>
    <br><br>

    <mat-tab-group>
      <mat-tab *ngFor="let scope of customer.scopes; let i = index" label="{{scope.desc}}">
        <ng-template matTabContent>
          <mat-accordion>
            <mat-expansion-panel *ngFor="let c of scope.claims; let i = index">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{c.desc}}
                  <ng-container *ngIf="privateClaim(c)">
                    <mat-icon class="small" matTooltip="Mitarbeiter-Zugang">perm_identity</mat-icon>
                  </ng-container>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <mat-card-content>
                <table class="mat-table data-table">
                  <ng-container *ngIf="privateClaim(c)">
                    <tr>
                      <th>Mitarbeiter-Zugang für</th>
                      <td>{{c.external_customer_id}}</td>
                    </tr>
                  </ng-container>
                  <tr>
                    <th>Id</th>
                    <td>{{c.id}}</td>
                  </tr>
                  <tr>
                    <th>Zugangsnummer</th>
                    <td>{{c.external_claim_id}}</td>
                  </tr>
                  <tr>
                    <th>Einladungs-Code</th>
                    <td>{{c.crc32}}</td>
                  </tr>
                  <tr>
                    <th>Aktivierungs-Schlüssel</th>
                    <td>{{c.md5}}</td>
                  </tr>
                  <tr>
                    <th>Maximale Anzahl der Zugänge</th>
                    <td>{{c.max_user_count}}</td>
                  </tr>
                  <tr>
                    <th>Anzahl der aktiven Zugänge</th>
                    <td>{{c.active_users}}
<!--                      <mat-icon class="active-usr-tt"-->
<!--                                *ngIf="c.active_users.length"-->
<!--                                matTooltip="{{getUsrTooltip(c.active_users)}}"-->
<!--                                mat-list-icon>help</mat-icon>-->
                    </td>
                  </tr>
                  <tr>
                    <th>Gültig von</th>
                    <td> {{c.start | date:'short'}}</td>
                  </tr>
                  <tr>
                    <th>Gültig bis</th>
                    <td> {{c.expires | date:'short'}}</td>
                  </tr>
                </table>

                <div class="actions">
                  <button [disabled]="!hasPermission(c)" (click)="addClaim2User(c)"
                          mat-raised-button>Zugang direkt hinzufügen
                    <mat-icon>person_add</mat-icon>
                  </button>
                  <br><br>
                  <button [disabled]="!hasPermission(c)" (click)="sendInvitation(c)"
                          mat-raised-button>Einladung per Email schicken
                    <mat-icon>mail_outline</mat-icon>
                  </button>
                </div>

              </mat-card-content>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

  </mat-expansion-panel>
</mat-accordion>
